"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Filter = function Filter() {
  return _react2.default.createElement(
    "g",
    { id: "filter" },
    _react2.default.createElement("path", {
      d: "M500,111.1 L500,55.6 L333.3,55.6 L333.3,111.2 L500,111.2 L500,111.1 Z M500,444.4 L500,388.8 L222.2,388.8 L222.2,444.4 L500,444.4 L500,444.4 Z M222.2,0 L222.2,55.6 L0,55.6 L0,111.2 L222.2,111.2 L222.2,166.8 L277.8,166.8 L277.8,0 L222.2,0 L222.2,0 Z M388.9,333.3 L388.9,277.7 L500,277.7 L500,222.1 L388.9,222.1 L388.9,166.5 L333.3,166.5 L333.3,333.2 L388.9,333.2 L388.9,333.3 Z M0,222.2 L0,277.8 L277.8,277.8 L277.8,222.2 L0,222.2 L0,222.2 Z M166.7,333.3 L111.1,333.3 L111.1,388.9 L0,388.9 L0,444.5 L111.1,444.5 L111.1,500 L166.7,500 L166.7,333.3 L166.7,333.3 Z",
      id: "Shape"
    })
  );
};

exports.default = Filter;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Filter.js
// module id = 2954
// module chunks = 4